/**
 *
 * @author Jesus R. Nava Cruz
 * @date May 26, 2023
 * @version 1.0
 *
 */

export default {
  path: "/app/config/espacios-fisicos",
  name: "ESPACIOS FISICOS",
  component: () => import("@/app/views/crud/CrudView.vue"),
  meta: {
    service: () => import("@/app/services/PhysicalSpacesService"),
    table: () => import("@/app/components/config/physicalSpaces/PhysicalSpacesTable"),
    form: () => import("@/app/components/config/physicalSpaces/PhysicalSpacesForm"),
    header: {
      icono: "mdi-home-city",
      texto: "Espacios físicos",
      textNew: "Agregar espacio",
      textEdit: "Modificar espacio"
    },
    prm: "ND",
    requireAuth: true,
    filterDate: false,
    filterModality: true,
    addButtonText: 'Nuevo Espacio',
    addButtonIcon: 'mdi-office-building-plus'
  },
};
